import React, { Component } from 'react';
import idx from 'idx';
import { SelectField, MoneyInputField } from 'common/components/form_fields';
import { getDetailedAwardCost } from 'pap/utils';
import Money from 'common/components/money';
import { AWARD_REFERENCES, DEFAULT_AWARD_REFERENCES } from 'pap/constants';
import ItemizedCost from 'common/components/itemized_cost';
import ReferenceSlider from 'common/components/reference_slider';
import FeesLabel from 'common/components/fees_label';

const OPTIONS = [
  { field: "request_quote", label: "Ask for a price quote" },
  { field: "send_offer", label: "Set my own price" }
];

export default class Budget extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(fieldName, value) {
    const { input, meta: { error={} } } = this.props;
    const currentValue = input.value || {}
    const updatedValue = { ...currentValue, [fieldName]: value };

    if (fieldName === "budget_option" && value !== currentValue.budget_option) {
      /* make sure award value is set to 0 when requesting quote */
      if (value === "request_quote") {
        updatedValue.award_1_1 = 0;
      /* make sure award value is set to minimum when sending offer */
      } else {
        updatedValue.award_1_1 = idx(this.getReferenceAward(), _ => _.feature.min) || 0;
      }
    }

    input.onChange(updatedValue);
  }

  getReferenceAward() {
    return this.props.currentAwards.find(a => a.feature.position === 0);
  }

  render() {
    const { input, meta: { error={} }, subCategory, projectData } = this.props;
    const stepValues = input.value || {};
    const referenceAward = this.getReferenceAward();
    const detailedCost = (
      (stepValues.budget_option === "send_offer" && referenceAward)?
      getDetailedAwardCost(referenceAward.feature, stepValues.award_1_1 || 0) :
      {}
    );
    const references = (
      AWARD_REFERENCES[idx(subCategory, _ => _.slug)] || DEFAULT_AWARD_REFERENCES
    );
    const creativeCount = (
      idx(projectData, _ => _.one_to_one_pre_negotiation_creative_ids) || []
    ).length;
    /* don't allow client to send an offer to multiple creatives (this assumes that
      `request_quote` is the default option)*/
    const canSetPrice = creativeCount <= 1;

    return (
      <div className="pap-budget row columns small-16">
        <div className="row columns small-16">
          <p className="budget-description">
            { canSetPrice?
            "You can ask for a price quote, or set your own price." :
            `You selected ${creativeCount} creatives. They will each send you a price quote based on your requirements. You can separately negotiate with each creative and pick the creative with whom you want to work.` }
          </p>
        </div>

        { canSetPrice &&
        <div className="row">
          <div className="columns small-16 medium-7">
            <SelectField meta={{}} options={OPTIONS}
              input={{
                value: stepValues.budget_option,
                name: "budget_option",
                onChange: (e) => this.handleChange("budget_option", e.target.value)
              }}
            />
          </div>
        </div> }

        { stepValues.budget_option === "send_offer" &&
        <div className="row offer-details">
          <div className="columns small-16 medium-7">
            <h4>The creative will be paid:</h4>
            <MoneyInputField
              meta={{
                error: error.award_1_1,
                touched: !!stepValues.award_1_1,
                invalid: !!error.award_1_1
              }}
              input={{
                value: stepValues.award_1_1,
                name: "award_1_1",
                onChange: (v) => this.handleChange("award_1_1", v)
              }}
            />
          </div>
          <div className="reference-wrapper columns small-16 medium-offset-1 medium-8 large-offset-2 large-7">
            <h4>Price guide</h4>
            <p>Based on how much freelancers typically charge for this category.</p>
            <ReferenceSlider references={references} value={stepValues.award_1_1 || 0} money={true} />
          </div>
        </div> }

        { stepValues.budget_option === "send_offer" && !!stepValues.award_1_1 &&
        <div className="row columns small-16 medium-6 large-5">
          <ItemizedCost items={[{
            value: stepValues.award_1_1,
            description: "award"
          }, {
            value: detailedCost.fees,
            description: <FeesLabel />
          }]} />
        </div> }
      </div>
    );
  }
};
